import React, {useState, useEffect, useContext} from 'react';
import makeTitle from 'function/makeTitle.js';
import {SectionTitle} from 'components/items';

// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/firestore';
import { authContext } from '../../shared/App';
var db = firebase.firestore();
const COLLECTION = "members";

const sectionTitle = [
  {
    text: "OUR",
    color: "defualt",
    break: false
  },{
    text: "MEMBERS",
    color: "main",
    break: true
  }
]


const Members = () => {
  const {setIsMemberLoading} = useContext(authContext);
  // get from firebase
  const _get = async () => {
    let result = [];
    const ref = await db.collection(COLLECTION).orderBy("priority").orderBy("name").get()
    ref.forEach(doc => {
      result.push({
        ...doc.data(),
        id: doc.id
      });
    })
    return result
  }
  
  const [members, setMembers] = useState([]);


  useEffect(()=> {
    const initData = async () => {
      setIsMemberLoading(true);
      setMembers(await _get());
      setIsMemberLoading(false);
    }
    initData()
  }, [setIsMemberLoading])

  const drawMembers= () => {
    return  <ul className="wrap-members">
              {members.map(el=> {
                return  <li className="member" key = {el.id}>
                          <div className="profile" style = {{backgroundImage :`url(${el.imageUrl})`}}>
                          </div>

                          <div className="wrap-text">
                            <p className="name">{el.name}</p>
                            <p className="position">{el.position}</p>
                          </div>
                        </li>
              })}
            </ul>
  }

  return (
    <section className="Members">
      <div className="section-header">
        <div className="con">
          <SectionTitle text = {makeTitle(sectionTitle)}  type = "center"/>
        </div>
      </div>
      
      <div className="section-contents">
        <div className="con">
          {drawMembers()}
        </div>
      </div>
    </section>
  );
}

export default Members;